import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  teamDetails: {
    //
  }
});

export default styles;
